module.exports = __webpack_public_path__ + "img/rm6.bfddc061.jpg";